import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[caSidebar]'
})
export class CaSidebarDirective implements OnChanges {
  @Input() resizevar: any; // bound from component
  @Input() screen!: { height: number };

  constructor(private el: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['resizevar']) {
      const height = this.el.nativeElement.offsetHeight;
      if (this.screen) {
        this.screen.height = height;
      }
    }
  }
}
